export default __webpack_public_path__ + "static/media/stary_page.61500584.png";